export default function (arr) {
  if (Array.isArray(arr) && arr.length > 0) {
    const lastIdx = arr.length - 1;
    return arr[lastIdx];
  }

  return arr;
}
